import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** The production origin used to build absolute canonical URLs. */
const SITE_ORIGIN = 'https://flyingmuse.gr';

/**
 * Keeps a single <link rel="canonical"> in <head> in sync with the current
 * route. The static index.html ships a canonical for "/"; this updates it on
 * every client-side navigation so each route advertises its own canonical URL.
 * The hash and query string are intentionally dropped - they don't represent
 * distinct canonical documents here.
 */
export function CanonicalManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Collapse a trailing slash (except for the root) so "/about/" and "/about"
    // don't advertise two different canonicals.
    const path = pathname !== '/' ? pathname.replace(/\/$/, '') : '/';
    const href = `${SITE_ORIGIN}${path}`;

    let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = href;
  }, [pathname]);

  return null;
}
